import { useEffect } from 'react';
export default function useColors(elementId, primaryColor, secondaryColor) {
    useEffect(function () {
        if (primaryColor && secondaryColor) {
            var element = document.getElementById(elementId);
            if (element) {
                element.style.setProperty('--color-site-primary', primaryColor);
                element.style.setProperty('--color-site-secondary', secondaryColor);
            }
        }
    }, [elementId, primaryColor, secondaryColor]);
}
